import { render } from "./CreditStatement.vue?vue&type=template&id=4706a982"
import script from "./CreditStatement.vue?vue&type=script&lang=js"
export * from "./CreditStatement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__